import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from './Button';
import { selectIsRunning } from '../../features/feedback/feedbackSlice';

/**
 * A `Button` that shows its own request: spinner, `loadingLabel` and disabled
 * while the thunk it fires is running, read from the store rather than kept in
 * a flag of the screen.
 *
 * For an action on one row, `pendingKey` names the row — the thunk's argument
 * when it is an id, its `id`, or the `pendingKey` the thunk declares — so the
 * other rows' buttons stay usable.
 *
 * `<PendingButton pendingOn={deleteZone} pendingKey={zone.id} icon={Trash2} ... />`
 *
 * @param {object} props - Everything `Button` takes, plus:
 * @param {Function|string} props.pendingOn - The thunk, or its `typePrefix`.
 * @param {string|number} [props.pendingKey]
 */
export const PendingButton = React.forwardRef(({ pendingOn, pendingKey, loading = false, ...rest }, ref) => {
  const running = useSelector(selectIsRunning(pendingOn, pendingKey));
  return <Button ref={ref} loading={loading || running} aria-busy={loading || running} {...rest} />;
});

PendingButton.displayName = 'PendingButton';
